import { Stack } from '@mui/material';
import { TableBackground } from '../style/CommonStyle';
import { EmptyIcon } from '../../layouts/dashboard/nav/IconButton';
import { DetailInfoText } from '../style/TextStyle';

export default function Empty({ content = '데이터가 없습니다.', sx = {} }) {
  return (
    <TableBackground justifyContent="center" alignItems="center" sx={sx}>
      <Stack alignItems="center" spacing={1.5}>
        <EmptyIcon />
        <DetailInfoText>{content}</DetailInfoText>
      </Stack>
    </TableBackground>
  );
}
